module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K1TWTRV.ac58c6df.jpg";